import * as http from '../request/http';
import { isConfigReport, isJourneyReport, isMultiConfigReport, isRelationalReport } from '../tsTypes/reportTypes';
export const ASYNC_REPORT_RESOLVE_REPORT_TYPE = {
  CONFIG: 'CONFIG',
  RELATIONAL: 'RELATIONAL',
  JOURNEY: 'JOURNEY',
  MULTI_CONFIG: 'MULTI_CONFIG'
};
export const ASYNC_REPORT_RESOLVE_REPORT_REQUEST_CACHE_ID_API = {
  CONFIG: 'reporting/v3/dataset/resolve/async',
  RELATIONAL: 'reporting/v3/report/resolve/async',
  JOURNEY: 'reporting/v3/journey/resolve/async',
  MULTI_CONFIG: 'reporting/v3/multidataset/resolve/async'
};
const getRequestCacheBaseUrlForReport = report => {
  if (isConfigReport(report)) {
    if (isMultiConfigReport(report)) {
      return ASYNC_REPORT_RESOLVE_REPORT_REQUEST_CACHE_ID_API.MULTI_CONFIG;
    } else {
      return ASYNC_REPORT_RESOLVE_REPORT_REQUEST_CACHE_ID_API.CONFIG;
    }
  } else if (isRelationalReport(report)) {
    return ASYNC_REPORT_RESOLVE_REPORT_REQUEST_CACHE_ID_API.RELATIONAL;
  } else if (isJourneyReport(report)) {
    return ASYNC_REPORT_RESOLVE_REPORT_REQUEST_CACHE_ID_API.JOURNEY;
  } else {
    throw new Error('Unsupported report type for getting cache key');
  }
};
export const getAsyncReportResolveIdAndTriggerFetch = (report, options = {
  fetchFromCache: false
}) => {
  const {
    fetchFromCache
  } = options;
  const apiUrl = getRequestCacheBaseUrlForReport(report);
  if (isConfigReport(report)) {
    return http.post(`${apiUrl}`, {
      data: Object.assign({}, report.toJS(), {
        fetchFromCache
      })
    }, {
      bust: true,
      ttl: 0,
      disableTtl: true
    });
  } else {
    return http.post(`${apiUrl}`, {
      data: Object.assign({}, report.toJS(), {
        reportOptions: {
          fetchFromCache
        }
      })
    }, {
      bust: true,
      ttl: 0,
      disableTtl: true
    });
  }
};
export const getAsyncReportResolveCacheKeyAndStatus = report => {
  const apiUrl = getRequestCacheBaseUrlForReport(report);
  if (isConfigReport(report)) {
    return http.post(`${apiUrl}/status`, {
      data: Object.assign({}, report.toJS())
    }, {
      bust: true,
      ttl: 0,
      disableTtl: true
    }).then(res => res.toJS());
  }
  return http.post(`${apiUrl}/status`, {
    data: Object.assign({}, report.toJS(), {
      reportOptions: {}
    })
  }, {
    bust: true,
    ttl: 0,
    disableTtl: true
  }).then(res => res.toJS());
};
export function getAsyncReportResolveAndPoll(report, id, options = {
  bust: true
}) {
  const apiUrl = getRequestCacheBaseUrlForReport(report);
  return http.get(`${apiUrl}/${id}`, undefined, options.bust ? {
    disableTtl: true,
    ttl: 0,
    bust: true
  } : {});
}